/** Tài khoản quản trị hệ thống: thấy mục "Nhà thuốc tổng", tìm thành viên theo email và cấp mọi vai trò (kể cả phòng xét nghiệm, cơ sở y tế, trạm thuốc, người kiểm định). */
export const ADMIN_EMAILS: readonly string[] = [
  'pkthienbinh@gmail.com',
  'khanhlq.upnet@gmail.com',
];

export function isAdminEmail(email?: string | null): boolean {
  return !!email && ADMIN_EMAILS.includes(email.trim().toLowerCase());
}
